export default "__VITE_PUBLIC_ASSET__59b3b408__"